<template>
  <GDrawer
    :model-value="isOpen"
    title="¿Qué moneda deseas añadir?"
    description="Selecciona la moneda que crearás, la creación es totalmente gratis."
    size="400px"
    destroy-on-close
    @close="closeDrawer"
  >
    <CreateWalletCurrency @currency-selected="handleCurrencySelected" />
  </GDrawer>
</template>

<script lang="ts" setup>
import { GDrawer } from '@flash-global66/g-drawer';

import type { CreateWalletDrawerEmit } from '../../types/createWalletDrawer.type';

import CreateWalletCurrency from '../CreateWalletCurrency/index.vue';
import { useCreateWalletDrawer } from './useCreateWalletDrawer';

const emit = defineEmits<CreateWalletDrawerEmit>();

const { isOpen, handleCurrencySelected, closeDrawer } = useCreateWalletDrawer(emit);
</script>
